module.exports = __webpack_public_path__ + "assets/img/5b25ef16bf906034b8dbb08eede0c501.png";